import { useMutation } from 'react-query'
import { postRemovePromoCode } from '../api'

const useRemovePromoCode = () => {
    const { mutateAsync, isLoading, isSuccess } =
        useMutation(postRemovePromoCode)
    return { mutateAsync, isLoading, isSuccess }
}

export default useRemovePromoCode
